import { ActionButtonConfig, ActionKey } from '../types/button/ActionButton';

export const actionButtonMap: Record<ActionKey, ActionButtonConfig> = {
  view: {
    label: 'Ver',
    className: 'bg-blue-600 hover:bg-blue-700',
    iconName: 'view',
  },
  edit: {
    label: 'Editar',
    className: 'bg-primary hover:bg-primary/90',
    iconName: 'edit',
  },
  trash: {
    label: 'Eliminar',
    className: 'bg-[#DC3545] hover:bg-opacity-90',
    iconName: 'trash',
  },
  cancel: {
    label: 'Anular',
    className: 'bg-[#DC3545] text-[#212B36] hover:bg-opacity-90',
    iconName: 'cancel',
  },
  'cancel-pending': {
    label: 'Cancelar compra',
    className: 'bg-[#DC3545] text-white hover:bg-opacity-90',
    iconName: 'cancel',
  },
  continue: {
    label: 'Continuar',
    className: 'bg-primary hover:bg-primary/90',
    iconName: 'continue',
  },
  process: {
    label: 'Procesar',
    className: 'bg-[#3CA745] hover:bg-opacity-90',
    iconName: 'process',
  },
  pdf: {
    label: 'Descargar PDF',
    className: 'bg-[#212B36] hover:bg-opacity-90',
    iconName: 'pdf',
  },
  json: {
    label: 'Descargar JSON',
    className: 'bg-[#a991d4] hover:bg-[#967cc3]',
    iconName: 'json',
  },
  dte: {
    label: 'Consultar DTE',
    className: 'bg-[#3CA745] hover:bg-opacity-90',
    iconName: 'search',
  },
  invalidDte: {
    label: 'DTE Invalidado',
    className: 'bg-[#637381] hover:bg-opacity-90',
    iconName: 'invalid',
  },
  print: {
    label: 'Imprimir',
    className: 'bg-[#212B36] hover:bg-opacity-90',
    iconName: 'print',
  },
  reprint: {
    label: 'Reimpresión de Ticket',
    className: 'bg-[#212B36] hover:bg-opacity-90',
    iconName: 'reprint',
  },
  email: {
    label: 'Enviar por correo',
    className: 'bg-[#3BA2B8] hover:bg-opacity-90',
    iconName: 'email',
  },
  close: {
    label: 'Cerrar',
    className: 'bg-primary hover:bg-primary/90',
    iconName: 'close',
  },
  settled: {
    label: 'Liquidado',
    className: 'bg-[#212B36] hover:bg-opacity-90',
    iconName: 'settled',
  },
  test: {
    label: 'Probar conexión',
    className: 'bg-[#17A2B8] hover:bg-[#138496]',
    iconName: 'test',
  },
  reverse: {
    label: 'Revertir',
    className: 'bg-yellow-500 hover:bg-yellow-600 text-black',
    iconName: 'reverse',
  },
  reject: {
    label: 'Rechazar',
    className: 'bg-[#DC3545] text-[#212B36] hover:bg-opacity-90',
    iconName: 'reject',
  },
  approve: {
    label: 'Aprobar',
    className: 'bg-green-600 hover:bg-green-700 text-white',
    iconName: 'check',
  },
  revert: {
    label: 'Revertir',
    className: 'bg-yellow-500 hover:bg-yellow-600 text-black',
    iconName: 'reverse',
  },
  resend: {
    label: 'Reenviar DTE',
    className: 'bg-orange-500 hover:bg-orange-600 text-white',
    iconName: 'refresh-cw',
  },
  pay: {
    label: 'Pagar',
    iconName: 'pay',
    className: 'bg-[#3CA745] hover:bg-opacity-90 text-white',
  },
  history: {
    label: 'Historial',
    iconName: 'history',
    className: 'bg-[#3BA2B8] hover:bg-opacity-90 text-white',
  },
  'dte-response': {
    label: 'Ver respuesta de Hacienda',
    iconName: 'search',
    className: 'bg-[#3CA745] hover:bg-opacity-90 text-white',
  },
  'dte-error': {
    label: 'Ver rechazo de Hacienda',
    iconName: 'search',
    className: 'bg-[#DC3545] hover:bg-opacity-90 text-white',
  },
  support: {
    label: 'Corrección de soporte',
    iconName: 'edit',
    className: 'bg-[#637381] hover:bg-opacity-90 text-white',
  },
  'return-event': {
    label: 'Crear evento de retorno',
    iconName: 'refresh-cw',
    className: 'bg-[#2563EB] hover:bg-[#1D4ED8] text-white',
  },

  'special-operation': {
    label: 'Generar operación especial',
    iconName: 'process',
    className: 'bg-[#7C3AED] hover:bg-[#6D28D9] text-white',
  },
};
